var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-content',[_c('live-stream',{attrs:{"session":_vm.session,"with-full-date":"","with-participants":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }